import React from "react";
import CommonModal from "./CommonModal";

import PropTypes from "prop-types";
import {
  alertActions,
  buttonName,
  invoiceTab,
  passwordConfirmModal
} from "../../locales/en";
import Style from "./modal.module.scss";
import FormError from "../common/FormError";

const CustomerStatusUpdateInfo = ({
  isOpen,
  toggle,
  errorData,
  onSubmit,
  password,
  setPassword,
  content,
  errorMessage
}) => {
  return (
    <CommonModal
      isOpen={isOpen}
      toggle={toggle}
      title={invoiceTab?.customerInvTable?.errMsg?.item3}
      bodyClassName={Style.statusUpdateBody}
      footerButtons={[
        {
          label: buttonName?.close,
          className: "btn btn-secondary",
          onClick: toggle
        },
        {
          label: alertActions?.Confirm,
          className: "btn btn-primary",
          onClick: onSubmit
        }
      ]}
    >
      <div className="row">
        <div className="mb-3">
          <ul className={Style.StatusErrorData}>
            {errorData &&
              errorData?.map((item, index) => {
                const parts = item?.split(":");
                const hasField = parts?.length > 1;
                const field = hasField ? parts[0]?.trim() : null;
                const message = hasField
                  ? parts?.slice(1)?.join(":")?.trim()
                  : parts[0]?.trim();

                return (
                  <li key={index}>
                    {field && <span>{field}:</span>} {message}
                  </li>
                );
              })}
          </ul>
        </div>
        <div className="mb-3">
          <div className={`${Style.modalInputwrap} ${Style.passwordModalWrap}`}>
            {content && (
              <label htmlFor="passwordInput" className="form-label">
                {content}
              </label>
            )}
            <div className={Style.formInput}>
              <input
                type="password"
                value={password}
                className="mt-2"
                onChange={(e) => setPassword(e.target.value)}
                placeholder={passwordConfirmModal?.placeholder}
              />
              {errorMessage && <FormError message={errorMessage} />}
            </div>
          </div>
        </div>
      </div>
    </CommonModal>
  );
};
CustomerStatusUpdateInfo.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  errorData: PropTypes.array,
  onSubmit: PropTypes.any,
  password: PropTypes.any,
  setPassword: PropTypes.any,
  content: PropTypes.any,
  errorMessage: PropTypes.string
};

export default CustomerStatusUpdateInfo;
